// src/components/Common/ColorSelector.js 
import React, { useState, useEffect } from 'react'; 
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Grid, 
  CircularProgress 
} from '@mui/material'; 
import { supabase } from '../../services/supabaseClient'; 

const ColorSelector = ({ value, onChange, rtlTextFieldProps }) => { 
  const [colors, setColors] = useState([]); 
  const [loading, setLoading] = useState(false); 

  // Fetch colors on component mount 
  useEffect(() => { 
    fetchColors(); 
  }, []); 

  const fetchColors = async () => { 
    try { 
      setLoading(true); 
      const { data, error } = await supabase 
        .from('colors') 
        .select('*') 
        .order('name', { ascending: true }); 

      if (error) throw error; 
      setColors(data || []); 
    } catch (error) { 
      console.error('Failed to fetch colors:', error); 
    } finally { 
      setLoading(false); 
    } 
  }; 

  // Handle color change 
  const handleColorChange = (e) => { 
    const colorId = e.target.value; 
    onChange(colorId); // Update the form with the selected color 
  }; 

  return ( 
    <Grid container spacing={2}> 
      <Grid item xs={12}> 
        <FormControl fullWidth>
          <InputLabel 
            id="color-select-label"
            {...rtlTextFieldProps.InputLabelProps}
            sx={{
              fontWeight: 'bold',
              left: 'auto',                // anchor on the right
              // only apply our offset when NOT shrunk:
              '&:not(.MuiInputLabel-shrink)': {
                right: 45,   
                // theme.spacing(2) → 16px
              },
              '&.MuiInputLabel-shrink': {
                right: 5,   // e.g. theme.spacing(1) → 8px
                // default MUI shrink transform is translate(X, Y) scale(0.75).
                // For RTL, X is negative, so we pick a small negative shift:
                transform: 'translateX(-8px) translateY(-6px) scale(0.75)',
              },
            }}
          > 
            اللون 
          </InputLabel> 
          {loading ? ( 
            <CircularProgress size={24} sx={{ 
              position: 'absolute', 
              top: '50%', 
              right: '50%', 
              marginTop: '-12px', 
              marginRight: '-12px' 
            }} /> 
          ) : ( 
            <Select 
              labelId="color-select-label"
              value={value || ''} 
              onChange={handleColorChange} 
              label="اللون" 
              inputProps={rtlTextFieldProps.inputProps}
              sx={{...rtlTextFieldProps.sx, '& .MuiSelect-select': { fontWeight: 'bold', textAlign: 'right'}}}
              MenuProps={{ 
                PaperProps: { 
                  style: { 
                    maxHeight: 300 
                  } 
                } 
              }} 
            > 
              <MenuItem value="" disabled sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
                <em>اختر اللون</em> 
              </MenuItem> 
              {colors.map((color) => ( 
                <MenuItem 
                  key={color.id} 
                  value={color.id} 
                  sx={{ fontWeight: 'bold', flexDirection: 'row-reverse' }} 
                > 
                  {color.name} 
                </MenuItem> 
              ))} 
            </Select> 
          )} 
        </FormControl> 
      </Grid> 
    </Grid> 
  ); 
}; 

export default ColorSelector;
